export const resetToDefaultBodyStyles = (document = window.document): void => {
  document.body.style.background = 'white';
};

export const displayLoginBodyStyles = (document = window.document): void => {
  document.body.style.background = 'linear-gradient(to bottom right, #147da4, #46b4d1) fixed';
};
